import { render, staticRenderFns } from "./redpacket_order_detail.vue?vue&type=template&id=130c86e6&scoped=true"
import script from "./redpacket_order_detail.vue?vue&type=script&lang=ts"
export * from "./redpacket_order_detail.vue?vue&type=script&lang=ts"
import style0 from "./redpacket_order_detail.vue?vue&type=style&index=0&id=130c86e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130c86e6",
  null
  
)

export default component.exports